const PokedexHome = () => import("@/views/pokedex/PokedexHome.vue"); // 图鉴首页
const PokemonDetail = () => import("@/views/pokedex/PokemonDetail.vue"); // 精灵详情页
const PokedexInfo = () => import("@/views/pokedex/PokedexInfo.vue"); // 其他说明页面或功能页

export default [
  {
    path: "/pokedex", // 图鉴首页
    name: "PokedexHome",
    component: PokedexHome,
  },
  {
    path: "/pokedex/detail/:id", // 精灵详情，带参数
    name: "PokemonDetail",
    component: PokemonDetail,
    props: true, // 允许通过 props 接收 id 参数
  },
  {
    path: "/pokedex/info", // 图鉴信息页（可选）
    name: "PokedexInfo",
    component: PokedexInfo,
  },
];
